var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    rx: 30.5,
    fill: "#246BFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3594 24.6406C38.8672 25.1094 38.8672 25.9297 38.3594 26.3984L28.3594 36.3984C27.8906 36.9062 27.0703 36.9062 26.6016 36.3984L21.6016 31.3984C21.0938 30.9297 21.0938 30.1094 21.6016 29.6406C22.0703 29.1328 22.8906 29.1328 23.3594 29.6406L27.5 33.7422L36.6016 24.6406C37.0703 24.1328 37.8906 24.1328 38.3594 24.6406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.8eb33c3d77d80dcd812d6b04b3a502fc.svg";
export { ForwardRef as ReactComponent };